/*RQ! code for "Add terms checkbox to the cart page" STARTS*/
$(document).ready(function(){

 
 $(".rq-validations-checked").click(function(){
      if ($(".rq-cart-page-checkbox-click").prop('checked')) {
      } else {  
        $(".rq-cart-popup-checkbox").attr("open", " ");
        setTimeout(function () {
          $(".rq-cart-popup-checkbox").removeAttr("open");
        }, 3000);    
      }
  });
  $(".rq-cart-page-checkbox-click").click(function(){
    var get_val = $(this).val();
     if ($(this).prop('checked')) {
        $(".rq-checked-remove-class").removeClass("rq-validations-checked");
     } else {
        $(".rq-checked-remove-class").addClass("rq-validations-checked");
     }
  });
  
});
/*RQ! code for "Add terms checkbox to the cart page" ENDS*/

/*RQ! code for "Migrate FAQ CSS" STARTS*/
$(document).ready(function(){
  $('.faq-question').on('click', function(){

    if( $(this).parent().hasClass('active') ){
      $(this).parent().siblings('.faq-accord').removeClass('active').children('.faq-answer').slideUp(150);
      $(this).next().slideUp(150).parent().removeClass('active');
    } else {

      $(this).parent().siblings('.faq-accord').removeClass('active').children('.faq-answer').slideUp(150);
      $(this).parent().addClass('active');
      $(this).next().slideDown(200, function() {
          $('html, body').delay('200').animate({
          scrollTop: $(this).offset().top - 350
          }, 200);
      });

    }

    
  });
});
/*RQ! code for "Migrate FAQ CSS" ENDS*/

/*RQ! code for "Cop Comment" STARTS*/
/*$('.js-cop-tooltip-trigger').tooltip({
  content: function () {
    return $(this).find('.js-cop-tooltip__container').html();
  },
  disabled: true,
  items: '.js-cop-tooltip-trigger',
  track: true,
  position: {
      at: 'center bottom',
      my: 'left top+5px',
  },
  tooltipClass: "cop-tooltip-active"
});

$('.js-cop-tooltip-trigger').hover(function() {
  $('.js-cop-tooltip-trigger').tooltip('open');
});


$('.js-cop-tooltip-trigger').on('click touchend', function(ev) {
  ev.preventDefault();
  ev.stopPropagation();
  $('.js-cop-tooltip-trigger').tooltip('open');
  $('body').on('click touchend', function(ev) {
    $('.js-cop-tooltip-trigger').tooltip('close');
  });
});*/
/*RQ! code for "Cop Comment" ENDS*/


/*RQ! code for "Migrate Flashlight comparison page"  TARTS*/

  function handle_mousedown(e){
		window.my_dragging = {};
		my_dragging.pageX0 = e.pageX;
		my_dragging.pageY0 = e.pageY;
		my_dragging.elem = this;
		my_dragging.offset0 = $(this).offset();
		function handle_dragging(e){
			var left = my_dragging.offset0.left + (e.pageX - my_dragging.pageX0);
			var dragger_right = ($(window).width() - ($('#dragger-pdf').offset().left + $('#dragger-pdf').outerWidth()));
			var dragger_width = ( $(window).width() - dragger_right) - 30;
			var top = 0;
			if( left > dragger_right && dragger_width > left ){
				$(my_dragging.elem).offset({left: left});
				top += left - dragger_right;
			}
			//var maxScrollLeft =  $('#main-pdftable-list').width() - $('.pdf-table-mobile-wrapper').width();
			$('#top-scroll-bar-wrapper').scrollLeft(top);
			
			
		}
		function handle_mouseup(e){
			$('body')
			.off('mousemove', handle_dragging)
			.off('mouseup', handle_mouseup);
		}
		$('body')
		.on('mouseup', handle_mouseup)
		.on('mousemove', handle_dragging);
	}
$(document).ready(function(){

$('#dragger').mousedown(handle_mousedown);
	
	$("#top-scroll-bar-wrapper").mCustomScrollbar({
		axis:"x",
		theme:"light-3",
		advanced:{autoExpandHorizontalScroll:true},
		callbacks :{
			whileScrolling : function(){
				var scrolling1 = $("#mCSB_1_container").css('left');
				var current_scroll = scrolling1.replace('-','').replace('px','');
				// console.log(current_scroll);
				$("#sticky-header-light-matrix").scrollLeft(current_scroll);
				$("#top-scroll-bar-wrapper").scrollLeft(current_scroll);
			}
		}
		
	});

  
 $('.pdf-table-tabs li a').on('click', function(e){
      $('.pdf-table-tabs li').removeClass('active');
      $(this).parent().addClass('active');

      $('.tabled.pdf-table > li').css('display','none');
      $('.grid_layout.pdf-table li').removeClass('display_important');
      $('.tabled.pdf-table li.'+ $(this).data('type') ).css('display','block');
      e.preventDefault();
    });
  
$('#pdftable-control-table').on('click', function(e){
        e.preventDefault();
        $('#top-scroll-bar-wrapper').css('visibility','visible');
        $('.slide-to-see-right').css('display','block');
        $('.instruction-pdftable').removeClass('hide');
        $('#pdftable-control-grid').removeClass('active');
        $('#pdftable-control-table').addClass('active');
        $('.pdf-table-tabs').css('display','none');
        $('ul.pdf-table-display.pdf-table').removeClass('tabled').addClass('grid_layout');
        $('#mobile-list-spec').removeClass('hide');
        $('#sticky-header-light-matrix').removeClass('hide');

            if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){} else{

            if($('#sticky-header-light-matrix').hasClass('remove-li-activate') ){
                // do nothing
            } else {
                // ---
                // ASP-19 :: Fix Flashlight Feature Comparison Table
                // createBarTitles();
                // getBarTableTitlesWidths();
                // end/ASP-19
            }
            var total_li_width = 0;
            $('#main-pdftable-list li.product-list').each( function(){
                total_li_width += $(this).width();
            });

            $('#main-pdftable-list').width(total_li_width+1).wrap('<div class="pdf-table-mobile-wrapper"></div>');
            $('#top-scroll-bar-pdf').width(total_li_width+3);

            if( $('#slide-to-see-right').hasClass('reload-active') ){ } else{
                $('#slide-to-see-right').append('<a href="" javascript="window.reload()">Reset Chart</a>');
            }
            $('#slide-to-see-right').addClass('reload-active');
            }

        $('.spec-table-title .spec-question-mark').hover(
            function(){
            if( $(this).parent().find('.description').text() ){
                $(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
            }
            },
            function(){ $('.appended-desc').remove(); }
        );

        $(".pdf-table-mobile-wrapper").scroll(function(){
            $("#sticky-header-light-matrix").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
            $("#top-scroll-bar-wrapper").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
        });
        $("#sticky-header-light-matrix").scroll(function(){
            $(".pdf-table-mobile-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
            $("#top-scroll-bar-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
        });
        $("#top-scroll-bar-wrapper").scroll(function(){
            $(".pdf-table-mobile-wrapper").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
            $("#sticky-header-light-matrix").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
        });

    });


    $('#pdftable-control-grid').on('click', function(e){
        $('#top-scroll-bar-wrapper').css('visibility', 'hidden');
        $('.slide-to-see-right').css('display', 'none');
        $('.instruction-pdftable').addClass('hide');
        $('#sticky-header-light-matrix').addClass('hide');
        $('#mobile-list-spec').addClass('hide');
        $('#pdftable-control-table').removeClass('active');
        $('#pdftable-control-grid').addClass('active');
        $('.container-container').remove();
        // $('.clone-pdf-table-title').remove();
        $('#main-pdftable-list').removeAttr('style').css({ 'display':'block'});
        $('.pdf-table-tabs').css('display','block');
        $('ul.pdf-table-display.pdf-table').removeClass('grid_layout').addClass('tabled');

        if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){
          $('#main-pdftable-list').unwrap('.pdf-table-mobile-wrapper');
        }
        e.preventDefault();
    });


     if( $('.rq-pdftable-main').hasClass('pdftable') ) {

        $('#pdftable-control-grid').removeClass('active');
        $('#pdftable-control-table').addClass('active');
        $('.pdf-table-tabs').css('display','none');
        $('ul.pdf-table-display.pdf-table').removeClass('tabled').addClass('grid_layout');

        if( $('#main-pdftable-list').parent().is('div.pdf-table-mobile-wrapper')){} else{

            // ---
            // ASP-19 :: Fix Flashlight Feature Comparison Table
            createBarTitles();
            getBarTableTitlesWidths();
            // end/ASP-19

            var total_li_width = 0;
            $('#main-pdftable-list li.product-list').each( function(){
                total_li_width += $(this).width();
            });
            var total_li_all_width = 0;
            $('#main-pdftable-list li').each( function(){
                total_li_all_width += $(this).width();
            });

            $('#main-pdftable-list').width(total_li_width+1).wrap('<div class="pdf-table-mobile-wrapper"></div>');
            $('#main-pdftable-list2').width(total_li_all_width+1);
            $('#top-scroll-bar-pdf').width(total_li_all_width+3);

            $('.remove-matix-column').each( function(){
                $(this).on('click', function(e) {
                    e.preventDefault();
            
                    $('.product-list.product-list-'+ $(this).parent().parent().parent().data('matrix-id') + '').remove();
                    
                    // $('.lightmatix-data-specs .image-con').addClass('no-heading-bar');
                    // $('#sticky-header-light-matrix .pdf-table.grid_layout').css('padding-top','0');
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-edc').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-transitional').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-duty').remove();
                    // $('#main-pdftable-list2 .clone-pdf-table-title.tile-strategic').remove();

                    // ---
                    // ASP-19 :: Fix Flashlight Feature Comparison Table
                    // after removing an item, calculate the width for all items again
                    getBarTableTitlesWidths();
                    // end/ASP-19

                    var total_li_width = 0;
                    $('#main-pdftable-list li.product-list').each( function(){
                        total_li_width += $(this).width();
                    });
                    var total_li_all_width = 0;
                    $('#main-pdftable-list li').each( function(){
                        total_li_all_width += $(this).width();
                    });
                    $('#main-pdftable-list').width(total_li_width+1);
                    $('#main-pdftable-list2').width(total_li_all_width+1);
                    $('#top-scroll-bar-pdf').width(total_li_all_width+3);

                    // $('#mobile-list-spec').addClass('remove-li-activate');
                    // $('#sticky-header-light-matrix').addClass('remove-li-activate');

                    if( $('#slide-to-see-right').hasClass('reload-active') ){ } else{
                        $('#slide-to-see-right').append('<a href="" javascript="window.reload()">Reset Chart</a>');
                    }
                    $('#slide-to-see-right').addClass('reload-active');

                    /********/
                    $('#printable-section').html('');

                    $("#main-pdftable-list").clone().each(function() {
                        $(this).find('.first-list').remove();
                        $(this).find('li').removeAttr('style');
                        var list = $(this);
                        var size = 9;
                        var current_size = 0;
                        var first_list = 1;
                        var more_list = 0;
                        list.children().each(function() {
                        if (++current_size > size) {
                            var new_list = $("<ul></ul>").insertAfter(list);
                            list = new_list;
                            current_size = 1;
                            first_list++;
                        }
                        list.append(this);
                        $('#printable-section').append(list);
                        });
                    });
                
                    $('#printable-section ul').removeAttr('id class style').addClass('grid_layout pdf-table').prepend( $('#main-pdftable-list li.first-list').html() );
                    $('#printable-section .spec-table-titles').wrap('<li class="first-list table-first"></li>');  
                    $('#printable-section .remove-matix-column').remove();
                
                    $('#printable-section .grid_layout.pdf-table li .wrap-in .wrap-image img').wrap('<div class="image-wrapper"></div>');
                    $('#printable-section .spec-table-title').addClass();
                    /* Height Fixer */
                    var ps_spec_1 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="1"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="1"]').height(ps_spec_1);
                    $('#printable-section .spec-table-title[data-spec-table-id="1"]').height(ps_spec_1);

                    var ps_spec_2 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="2"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="2"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="2"]').height(50);

                    var ps_spec_3 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="3"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="3"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="3"]').height(50);

                    var ps_spec_4 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="4"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="4"]').height(40);
                    $('#printable-section .spec-table-title[data-spec-table-id="4"]').height(40);

                    var ps_spec_5 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="5"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="5"]').height(40);
                    $('#printable-section .spec-table-title[data-spec-table-id="5"]').height(40);

                    var ps_spec_6 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="6"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="6"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="6"]').height(50);

                    var ps_spec_7 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="7"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="7"]').height(60);
                    $('#printable-section .spec-table-title[data-spec-table-id="7"]').height(60);

                    var ps_spec_8 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="8"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="8"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="8"]').height(70);

                    var ps_spec_9 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="9"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="9"]').height(ps_spec_9);
                    $('#printable-section .spec-table-title[data-spec-table-id="9"]').height(ps_spec_9);

                    var ps_spec_10 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="10"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="10"]').height(ps_spec_10);
                    $('#printable-section .spec-table-title[data-spec-table-id="10"]').height(ps_spec_10);

                    var ps_spec_11 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="11"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="11"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="11"]').height(70);

                    var ps_spec_12 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="12"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="12"]').height(ps_spec_12);
                    $('#printable-section .spec-table-title[data-spec-table-id="12"]').height(ps_spec_12);

                    var ps_spec_13 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="13"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="13"]').height(ps_spec_13);
                    $('#printable-section .spec-table-title[data-spec-table-id="13"]').height(ps_spec_13);

                    var ps_spec_14 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="14"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="14"]').height(50);
                    $('#printable-section .spec-table-title[data-spec-table-id="14"]').height(50);

                    var ps_spec_15 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="15"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="15"]').height(ps_spec_15);
                    $('#printable-section .spec-table-title[data-spec-table-id="15"]').height(ps_spec_15);

                    var ps_spec_16 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="16"]').map(function (){ return $(this).height(); }).get());
                    $('#printable-section .product-spec[data-spec-id="16"]').height(70);
                    $('#printable-section .spec-table-title[data-spec-table-id="16"]').height(70);
            
                });
            });
        
        }

  $('.spec-table-title .spec-question-mark').hover(
    function(){
      if( $(this).parent().find('.description').text() ){        
        $(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
      }
    },
    function(){ $('.appended-desc').remove(); }
  );
  
  $('.spec-table-title .spec-question-mark').each( function(){
	  $(this).on('click', function(e){
		  if (window.matchMedia('(max-width: 1150px)').matches){
			  
			  $('.spec-table-title .appended-desc').remove();
			  
			  if( $(this).parent().find('.description').text() ){    
				$(this).parent().append('<div class="appended-desc">'+$(this).parent().find('.description').text()+'</div>');
			  }
		  }
	  })
  });
  
  
  //$( "#main-pdftable-list2" ).clone().appendTo( "#printable-section" );
  
  $("#main-pdftable-list").clone().each(function() {
	$(this).find('.first-list').remove();
	$(this).find('li').removeAttr('style');
    var list = $(this);
    var size = 9;
    var current_size = 0;
	var first_list = 1;
	var more_list = 0;
    list.children().each(function() {
      if (++current_size > size) {
        var new_list = $("<ul></ul>").insertAfter(list);
        list = new_list;
        current_size = 1;
		first_list++;
      }
	  list.append(this);
      $('#printable-section').append(list);
    });
  });
  
  $('#printable-section ul').removeAttr('id class style').addClass('grid_layout pdf-table').prepend( $('#main-pdftable-list li.first-list').html() );
  $('#printable-section .spec-table-titles').wrap('<li class="first-list table-first"></li>');  
  $('#printable-section .remove-matix-column').remove();
  
  $('#printable-section .grid_layout.pdf-table li .wrap-in .wrap-image img').wrap('<div class="image-wrapper"></div>');
  $('#printable-section .spec-table-title').addClass();
  
  
  /* Height Fixer */
var ps_spec_1 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="1"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="1"]').height(ps_spec_1);
$('#printable-section .spec-table-title[data-spec-table-id="1"]').height(ps_spec_1);

var ps_spec_2 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="2"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="2"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="2"]').height(50);

var ps_spec_3 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="3"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="3"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="3"]').height(50);

var ps_spec_4 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="4"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="4"]').height(40);
$('#printable-section .spec-table-title[data-spec-table-id="4"]').height(40);

var ps_spec_5 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="5"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="5"]').height(40);
$('#printable-section .spec-table-title[data-spec-table-id="5"]').height(40);

var ps_spec_6 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="6"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="6"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="6"]').height(50);

var ps_spec_7 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="7"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="7"]').height(60);
$('#printable-section .spec-table-title[data-spec-table-id="7"]').height(60);

var ps_spec_8 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="8"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="8"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="8"]').height(70);

var ps_spec_9 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="9"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="9"]').height(ps_spec_9);
$('#printable-section .spec-table-title[data-spec-table-id="9"]').height(ps_spec_9);

var ps_spec_10 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="10"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="10"]').height(ps_spec_10);
$('#printable-section .spec-table-title[data-spec-table-id="10"]').height(ps_spec_10);

var ps_spec_11 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="11"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="11"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="11"]').height(70);

var ps_spec_12 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="12"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="12"]').height(ps_spec_12);
$('#printable-section .spec-table-title[data-spec-table-id="12"]').height(ps_spec_12);

var ps_spec_13 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="13"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="13"]').height(ps_spec_13);
$('#printable-section .spec-table-title[data-spec-table-id="13"]').height(ps_spec_13);

var ps_spec_14 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="14"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="14"]').height(50);
$('#printable-section .spec-table-title[data-spec-table-id="14"]').height(50);

var ps_spec_15 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="15"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="15"]').height(ps_spec_15);
$('#printable-section .spec-table-title[data-spec-table-id="15"]').height(ps_spec_15);

var ps_spec_16 = Math.max.apply(null, $('#printable-section .product-spec[data-spec-id="16"]').map(function (){ return $(this).height(); }).get());
$('#printable-section .product-spec[data-spec-id="16"]').height(70);
$('#printable-section .spec-table-title[data-spec-table-id="16"]').height(70);

  console.log('append to print');

  }


  if($('.rq-pdftable-main').hasClass('pdftable')){ $('#PageContainer').removeClass('is-moved-by-drawer');

  $(window).scroll(function(e){

    var lightmatrixtop = $('#main-pdftable-list2').offset().top;
    console.log(lightmatrixtop);
	
    if ($(this).scrollTop() > 360){
		$('#pdftable-main-container').addClass('enable_sticky');
    }

    if ($(this).scrollTop() < 360){
      $('#pdftable-main-container').removeClass('enable_sticky');
    }
    // console.log( $(this).scrollTop() )  ;
  });

  }
  
  $(".pdf-table-mobile-wrapper").scroll(function(){
    $("#sticky-header-light-matrix").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
	$("#top-scroll-bar-wrapper").scrollLeft($(".pdf-table-mobile-wrapper").scrollLeft());
  });
  $("#sticky-header-light-matrix").scroll(function(){
    $(".pdf-table-mobile-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
	$("#top-scroll-bar-wrapper").scrollLeft($("#sticky-header-light-matrix").scrollLeft());
  });
  $("#top-scroll-bar-wrapper").scroll(function(){
    $(".pdf-table-mobile-wrapper").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
	$("#sticky-header-light-matrix").scrollLeft($("#top-scroll-bar-wrapper").scrollLeft());
	
	// console.log('scrolling');
  });

    $('.pdf-table.grid_layout li.product-list').each(
	function(){
	$(this).hover(
	function(){
		$('.pdf-table.grid_layout li.product-list').removeClass('hovering');
		$(this).addClass('hovering');
		$('.pdf-table.grid_layout li.product-list-' + $(this).data('matrix-id') + '').addClass('hovering');
	}, function(){
		$(this).removeClass('hovering');
		$('.pdf-table.grid_layout li.product-list-' + $(this).data('matrix-id') + '').removeClass('hovering');
	});
	}
  );
  
  
  $('.product-spec').hover( function(){
	  $(this).addClass('spec_active');
	  $('.product-spec[data-spec-id="'+$(this).data('spec-id') + '"]').addClass('spec_hover');
  }, function(){
	  $(this).removeClass('spec_active');
	  $('.product-spec[data-spec-id="'+$(this).data('spec-id') + '"]').removeClass('spec_hover');
  } );
  
});

function createBarTitles() {
    var tableFirstList = $('#main-pdftable-list2 li.first-list');
    tableFirstList.append('<div class="bar-table-titles" id="bar-table-titles" style="display: flex; position: absolute; left: 87px; top: 0;">');
    var tableBarTitles = tableFirstList.find('.bar-table-titles');
    tableBarTitles.append('<div style="position: static;" class="clone-clone-pdf-table-title clone-pdf-table-title tile-edc">EDC (Every Day Carry)</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-pdf-table-title tile-transitional">TRANSITIONAL</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-clone-pdf-table-title clone-pdf-table-title tile-duty">DUTY</div>');
    tableBarTitles.append('<div style="position: static;" class="clone-pdf-table-title tile-strategic">STRATEGIC</div>');
}

function getBarTableTitlesWidths() {
    var titles = ['edc', 'transitional', 'duty', 'strategic'];

    jQuery.each(titles, function(i, name) {
        jQuery( '.tile-'+ name +'' ).css( 'width', calculateBarTitleWidth( '#main-pdftable-list2 .pdftable-content-'+ name +'' ) );
    });
}

function calculateBarTitleWidth( els ) {
    var groupWidth = 0;
    jQuery(els).each(function() {
        groupWidth += jQuery(this).width();
    });
    return groupWidth;
}

$(document).ready(function(){
  $('.rq-descreadmore').click(function (event) {
          event.preventDefault();
                   var descriptionFull = document.querySelector('.rq-product-description-full');
                   descriptionFull.style.display = 'block';
                   var descriptionShort = document.querySelector('.rq-product-description-short');
                               descriptionShort.style.display = 'none';
  });
  $('.rq-descreadless').click(function (event) {
                   event.preventDefault();
                   var descriptionFull = document.querySelector('.rq-product-description-full');
                   descriptionFull.style.display = 'none';
                   var descriptionShort = document.querySelector('.rq-product-description-short');
                  descriptionShort.style.display = 'block';
  });
})  
/*RQ! code for "Migrate Flashlight comparison page"  ENDS*/  

